/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Catch Member API
 * API for Catch Member Backend
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CreateLeadDto,
  CreateLeadResponseDto,
  PpraSurveyControllerSaveAnswerBody,
  ProblemDetail,
  SessionSurveyDto,
  SurveyResultsDto
} from '.././model'
import { customFetcher } from '../../../client/customFetcher';



export const ppraSurveyControllerGetLatestResults = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<SurveyResultsDto>(
      {url: `/session/me/ppra/latest-results`, method: 'GET', signal
    },
      );
    }
  

export const getPpraSurveyControllerGetLatestResultsQueryKey = () => {
    return [`/session/me/ppra/latest-results`] as const;
    }

    
export const getPpraSurveyControllerGetLatestResultsQueryOptions = <TData = Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError = ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPpraSurveyControllerGetLatestResultsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>> = ({ signal }) => ppraSurveyControllerGetLatestResults(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError, TData> & { queryKey: QueryKey }
}

export type PpraSurveyControllerGetLatestResultsQueryResult = NonNullable<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>>
export type PpraSurveyControllerGetLatestResultsQueryError = ProblemDetail

export const usePpraSurveyControllerGetLatestResults = <TData = Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetLatestResults>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPpraSurveyControllerGetLatestResultsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const ppraSurveyControllerCreateLead = (
    createLeadDto: CreateLeadDto,
 ) => {
      
      
      return customFetcher<CreateLeadResponseDto>(
      {url: `/session/me/ppra/lead`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLeadDto
    },
      );
    }
  


export const getPpraSurveyControllerCreateLeadMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>, TError,{data: CreateLeadDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>, TError,{data: CreateLeadDto}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>, {data: CreateLeadDto}> = (props) => {
          const {data} = props ?? {};

          return  ppraSurveyControllerCreateLead(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PpraSurveyControllerCreateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>>
    export type PpraSurveyControllerCreateLeadMutationBody = CreateLeadDto
    export type PpraSurveyControllerCreateLeadMutationError = ProblemDetail

    export const usePpraSurveyControllerCreateLead = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>, TError,{data: CreateLeadDto}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof ppraSurveyControllerCreateLead>>,
        TError,
        {data: CreateLeadDto},
        TContext
      > => {

      const mutationOptions = getPpraSurveyControllerCreateLeadMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const ppraSurveyControllerSaveAnswer = (
    sessionSurveyId: string,
    surveyItemId: string,
    ppraSurveyControllerSaveAnswerBody: PpraSurveyControllerSaveAnswerBody,
 ) => {
      
      
      return customFetcher<SessionSurveyDto>(
      {url: `/session/me/ppra/${sessionSurveyId}/question/${surveyItemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: ppraSurveyControllerSaveAnswerBody
    },
      );
    }
  


export const getPpraSurveyControllerSaveAnswerMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>, TError,{sessionSurveyId: string;surveyItemId: string;data: PpraSurveyControllerSaveAnswerBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>, TError,{sessionSurveyId: string;surveyItemId: string;data: PpraSurveyControllerSaveAnswerBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>, {sessionSurveyId: string;surveyItemId: string;data: PpraSurveyControllerSaveAnswerBody}> = (props) => {
          const {sessionSurveyId,surveyItemId,data} = props ?? {};

          return  ppraSurveyControllerSaveAnswer(sessionSurveyId,surveyItemId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PpraSurveyControllerSaveAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>>
    export type PpraSurveyControllerSaveAnswerMutationBody = PpraSurveyControllerSaveAnswerBody
    export type PpraSurveyControllerSaveAnswerMutationError = ProblemDetail

    export const usePpraSurveyControllerSaveAnswer = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>, TError,{sessionSurveyId: string;surveyItemId: string;data: PpraSurveyControllerSaveAnswerBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof ppraSurveyControllerSaveAnswer>>,
        TError,
        {sessionSurveyId: string;surveyItemId: string;data: PpraSurveyControllerSaveAnswerBody},
        TContext
      > => {

      const mutationOptions = getPpraSurveyControllerSaveAnswerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const ppraSurveyControllerGetPpraResults = (
    sessionSurveyId: string,
 signal?: AbortSignal
) => {
      
      
      return customFetcher<SurveyResultsDto>(
      {url: `/session/me/ppra/${sessionSurveyId}/results`, method: 'GET', signal
    },
      );
    }
  

export const getPpraSurveyControllerGetPpraResultsQueryKey = (sessionSurveyId: string,) => {
    return [`/session/me/ppra/${sessionSurveyId}/results`] as const;
    }

    
export const getPpraSurveyControllerGetPpraResultsQueryOptions = <TData = Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError = ProblemDetail>(sessionSurveyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPpraSurveyControllerGetPpraResultsQueryKey(sessionSurveyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>> = ({ signal }) => ppraSurveyControllerGetPpraResults(sessionSurveyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionSurveyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError, TData> & { queryKey: QueryKey }
}

export type PpraSurveyControllerGetPpraResultsQueryResult = NonNullable<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>>
export type PpraSurveyControllerGetPpraResultsQueryError = ProblemDetail

export const usePpraSurveyControllerGetPpraResults = <TData = Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError = ProblemDetail>(
 sessionSurveyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ppraSurveyControllerGetPpraResults>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPpraSurveyControllerGetPpraResultsQueryOptions(sessionSurveyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const ppraSurveyControllerCreatePpraSurvey = (
    version: string,
 ) => {
      
      
      return customFetcher<SessionSurveyDto>(
      {url: `/session/me/ppra/${version}`, method: 'POST'
    },
      );
    }
  


export const getPpraSurveyControllerCreatePpraSurveyMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>, TError,{version: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>, TError,{version: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>, {version: string}> = (props) => {
          const {version} = props ?? {};

          return  ppraSurveyControllerCreatePpraSurvey(version,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PpraSurveyControllerCreatePpraSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>>
    
    export type PpraSurveyControllerCreatePpraSurveyMutationError = ProblemDetail

    export const usePpraSurveyControllerCreatePpraSurvey = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>, TError,{version: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof ppraSurveyControllerCreatePpraSurvey>>,
        TError,
        {version: string},
        TContext
      > => {

      const mutationOptions = getPpraSurveyControllerCreatePpraSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    